import React from "react";
import { useHistory } from "react-router-dom";

const PrivacyPolicy = () => {
  const history = useHistory();

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      padding: "20px",
      overflowY: "auto",
      height: "100vh",
    },
    contentWrapper: {
      maxWidth: "900px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      padding: "25px",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
    header: {
      textAlign: "center",
      marginBottom: "30px",
      paddingBottom: "20px",
      borderBottom: "2px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "10px",
    },
    section: {
      marginBottom: "30px",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: "600",
      color: "#444",
      marginBottom: "15px",
    },
    paragraph: {
      fontSize: "14px",
      lineHeight: "1.4",
      color: "#666",
      marginBottom: "15px",
      textAlign: "justify",
    },
    list: {
      paddingLeft: "20px",
      marginBottom: "15px",
    },
    listItem: {
      fontSize: "14px",
      lineHeight: "1.8",
      color: "#666",
      marginBottom: "10px",
    },
    backButton: {
      cursor: "pointer",
      color: "#007bff",
      textDecoration: "none",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
    },
    contactInfo: {
      backgroundColor: "#f8f9fa",
      padding: "20px",
      borderRadius: "5px",
      marginTop: "20px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <div style={styles.header}>
          <div style={styles.backButton} onClick={() => history.goBack()}>
            <i className="mdi mdi-keyboard-backspace"></i>
          </div>
          <h1 style={styles.title}>Privacy Policy</h1>
        </div>

        <div style={styles.section}>
          <p style={styles.paragraph}>
            This Privacy Policy is an electronic record in the form of an
            electronic contract formed under the Information Technology Act,
            2000 and the rules made thereunder and the amended provisions
            pertaining to electronic documents/records in various statutes as
            amended by the Information Technology Act, 2000. This Privacy Policy
            does not require any physical, electronic or digital signature.
          </p>
          <p style={styles.paragraph}>
            This Privacy Policy is a legally binding document between you and
            AdhyayanYatra EduTech LLP (both terms defined below). The terms of
            this Privacy Policy will be effective upon your acceptance of the
            same (directly or indirectly in electronic form, by clicking on the
            I accept tab or by use of the website/Mobile App or by other means)
            and will govern the relationship between you AdhyayanYatra EduTech
            LLP for your use of the website(defined below).
          </p>
          <p style={styles.paragraph}>
            This document is published and shall be construed in accordance with
            the provisions of the Information Technology (Reasonable security
            practices and procedures and sensitive personal data of information)
            rules, 2011 under Information Technology Act, 2000; that require
            publishing of the Privacy Policy for collection, use, storage and
            transfer of sensitive personal data or information.
          </p>
          <p style={styles.paragraph}>
            Please read this Privacy Policy carefully by using the Website or
            Mobile App, you indicate that you understand, agree and consent to
            this Privacy Policy. If you do not agree with the terms of this
            Privacy Policy, please do not use this Website or Mobile App.
          </p>
          <p style={styles.paragraph}>
            By providing us with your Information or by making use of the
            facilities provided by the Website/Mobile App, You hereby consent to
            the collection, storage, processing and transfer of any or all of
            Your Personal Information and Non-Personal Information by us as
            specified under this Privacy Policy. You further agree that such
            collection, use, storage and transfer of Your Information shall not
            cause any loss or wrongful gain to you or any other person.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>User Information</h2>
          <p style={styles.paragraph}>
            To avail certain services on our Website or Mobile App, users are
            required to provide certain information for the registration process
            namely: - a) your name, b) email address, c) sex, d) age, e) PIN
            code, f) credit card or debit card details, g) password etc., and /
            or your occupation, interests, and the like. The Information as
            supplied by the users enables us to improve our sites and provide
            you the most user-friendly experience.
          </p>
          <p style={styles.paragraph}>
            All required information is service dependent and we may use the
            above-said user information to, maintain, protect, and improve its
            services (including advertising services) and for developing new
            services
          </p>
          <p style={styles.paragraph}>
            Such information will not be considered as sensitive if it is freely
            available and accessible in the public domain or is furnished under
            the Right to Information Act, 2005 or any other law for the time
            being in force.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Cookies</h2>
          <p style={styles.paragraph}>
            To improve the responsiveness of the Website or Mobile App for our
            users, we may use "cookies", or similar electronic tools to collect
            information to assign each visitor a unique, random number as a User
            Identification (User ID) to understand the user's individual
            interests using the Identified Computer or Mobile Device. Unless you
            voluntarily identify yourself (through registration, for example),
            we will have no way of knowing who you are, even if we assign a
            cookie to your computer/mobile device. The only personal information
            a cookie can contain is information you supply (an example of this
            is when you ask for our Personalised Horoscope). A cookie cannot
            read data off your hard drive. Our advertisers may also assign their
            own cookies to your browser (if you click on their ads), a process
            that we do not control.
          </p>
          <p style={styles.paragraph}>
            Our web servers automatically collect limited information about your
            device's connection to the Internet, including your IP address, when
            you visit our site or application. (Your IP address is a number that
            lets devices attached to the Internet know where to send you data --
            such as the web pages you view.) Your IP address does not identify
            you personally. We use this information to deliver our
            webpages/contents to you upon request, to tailor our
            site/application to the interests of our users, to measure traffic
            within our site and let advertisers know the geographic locations
            from where our visitors come.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Links to the Other Sites</h2>
          <p style={styles.paragraph}>
            Our policy discloses the privacy practices for our own web site and
            Mobile application only. It provides links to other websites and
            servers also that are beyond our control. We shall in no way be
            responsible in way for your use of such sites.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Information Sharing</h2>
          <p style={styles.paragraph}>
            We shares the sensitive personal information to any third a party
            without obtaining the prior consent of the user in the following
            limited circumstances:
          </p>
          <p style={styles.paragraph}>
            (a) When it is requested or required by law or by any court or
            governmental agency or authority to disclose, for the purpose of
            verification of identity, or for the prevention, detection,
            investigation including cyber incidents, or for prosecution and
            punishment of offences. These disclosures are made in good faith and
            belief that such disclosure is reasonably necessary for enforcing
            these Terms; for complying with the applicable laws and regulations.
          </p>
          <p style={styles.paragraph}>
            (b) We proposes to share such information within its group companies
            and officers and employees of such group companies for the purpose
            of processing personal information on its behalf. We also ensure
            that these recipients of such information agree to process such
            information based on our instructions and in compliance with this
            Privacy Policy and any other appropriate confidentiality and
            security measures.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Information Security</h2>
          <p style={styles.paragraph}>
            We take appropriate security measures to protect against
            unauthorized access to or unauthorized alteration, disclosure or
            destruction of data. These include internal reviews of our data
            collection, storage and processing practices and security measures,
            including appropriate encryption and physical security measures to
            guard against unauthorized access to systems where we store personal
            data.
          </p>
          <p style={styles.paragraph}>
            All information gathered on our Website or in the mobile application
            is securely stored within our controlled database. The database is
            stored on servers secured behind a firewall; access to the servers
            is password-protected and is strictly limited. However, as effective
            as our security measures are, no security system is impenetrable. We
            cannot guarantee the security of our database, nor can we guarantee
            that information you supply will not be intercepted while being
            transmitted to us over the Internet. And, of course, any information
            you include in a posting to the discussion areas is available to
            anyone with Internet access.
          </p>
          <p style={styles.paragraph}>
            However the internet is an ever evolving medium. We may change our
            Privacy Policy from time to time to incorporate necessary future
            changes. Of course, our use of any information we gather will always
            be consistent with the policy under which the information was
            collected, regardless of what the new policy may be.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Grievance Redressal</h2>
          <p style={styles.paragraph}>
            Redressal Mechanism: Any complaints, abuse or concerns with regards
            to content and or comment or breach of these terms shall be
            immediately informed to the designated Grievance Officer as
            mentioned below via in writing or through email signed with the
            electronic signature to Harsh Patel ("Grievance Officer").
          </p>
          <div style={styles.contactInfo}>
            <p
              style={{
                ...styles.paragraph,
                marginBottom: "10px",
                fontWeight: "600",
              }}
            >
              (Grievance Officer)
            </p>
            <p style={{ ...styles.paragraph, marginBottom: "5px" }}>
              Mrs.Pushpaben Patel
            </p>
            <p style={{ ...styles.paragraph, marginBottom: "5px" }}>
              Company Name: AdhyayanYatra EduTech LLP,
            </p>
            <p style={{ ...styles.paragraph, marginBottom: "5px" }}>
              223, Akodara, Himatnagar, Sabarkantha, Gujarat 383001
            </p>
            <p style={{ ...styles.paragraph, marginBottom: "5px" }}>
              Website: www.adhyayanyatra.com
            </p>
            <p style={{ ...styles.paragraph, marginBottom: "5px" }}>
              Email: support@adhyayanyatra.com
            </p>
            <p style={{ ...styles.paragraph, marginBottom: "0px" }}>
              Ph: +91 9408770877
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
